import React, { useState, useEffect, createContext, useContext } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Precommande from './pages/Precommande';
import Portail from './pages/Portail';
import PageCorpo from './pages/PageCorpo';
import PageEvenement from './pages/PageEvenement';
import PageContrat from './pages/PageContrat';
import RechercheCorpo from './pages/RechercheCorpo';
import Hub from './pages/Hub';
import ModalRetouver from './components/ModalRetouver';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const SettingsContext = createContext({
  logo_url: null,
  couleur_primaire: '#c8941a',
  nom_entreprise: 'Escamel Artisans du Fumoir',
  countdown_actif: '1',
});

export function useSettings() {
  return useContext(SettingsContext);
}

function AppRoutes() {
  const [modalRetouver, setModalRetouver] = useState(false);
  const { pathname } = useLocation();

  return (
    <>
      <Routes>
        <Route path="/evenement/:slug"   element={<PageEvenement />} />
        <Route path="/precommande/:slug" element={<Precommande />} />
        <Route path="/commande"          element={<Portail />} />
        <Route path="/corpo/:token"      element={<PageCorpo />} />
        <Route path="/contrat/:token"    element={<PageContrat />} />
        <Route path="/recherche-corpo"   element={<RechercheCorpo />} />
        <Route path="/"                  element={<Hub />} />
        <Route path="*" element={
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            minHeight: '100vh', flexDirection: 'column', gap: 12,
          }}>
            <div style={{ fontFamily: 'Cinzel, serif', color: 'var(--accent)', fontSize: 22 }}>
              ESCAMEL
            </div>
            <div style={{ color: 'var(--muted)', fontSize: 14 }}>Page introuvable.</div>
          </div>
        } />
      </Routes>

      {pathname !== '/recherche-corpo' && (
        <button className="btn-retrouver-flottant" onClick={() => setModalRetouver(true)}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="#c8941a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          Retrouver ma commande
        </button>
      )}
      <ModalRetouver ouvert={modalRetouver} fermer={() => setModalRetouver(false)} />
    </>
  );
}

export default function App() {
  const [settings, setSettings] = useState({
    logo_url: null,
    couleur_primaire: '#c8941a',
    nom_entreprise: 'Escamel Artisans du Fumoir',
    countdown_actif: '1',
  });

  useEffect(() => {
    fetch(`${API}/api/settings`)
      .then(r => r.json())
      .then(data => {
        if (!Array.isArray(data)) return;
        const map = {};
        data.forEach(s => { map[s.cle] = s.valeur; });
        // Normaliser logo_url : si chemin relatif → préfixer avec l'URL du backend
        if (map.logo_url && !map.logo_url.startsWith('http')) {
          map.logo_url = `${API}${map.logo_url}`;
        }
        setSettings(prev => ({ ...prev, ...map }));

        const couleur = map.couleur_primaire;
        if (couleur) {
          document.documentElement.style.setProperty('--accent', couleur);
          document.documentElement.style.setProperty('--gold-500', couleur);
        }

        // Favicon — cache-bust après chargement settings
        const link = document.getElementById('dynamic-favicon');
        if (link) link.href = `/api/parametres/general/favicon?t=${Date.now()}`;
      })
      .catch(() => { /* Silencieux — valeurs par défaut utilisées */ });
  }, []);

  return (
    <SettingsContext.Provider value={settings}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </SettingsContext.Provider>
  );
}
